<!--
  作者：顾先生
-->
<template>
  <div id="ShouYe" :style="{opacity:( ShowOK ? 1 : 0)}">
    <!--    头部+主要内容-->
    <div class="touBox1 clearfix">
      <img src="../assets/zhishi/logo.png" class="logoImg">
      <div class="zhuTi2 public_boxShaw public_Width">
        <div class="font226Xin">{{ companyShuju.company }}</div>
<!--        <div class="font226Xin2">经企业大数据检测，我们发现贵司的<span style="color:#A0785E;">商标注册地址与-->
<!--公司注册地址存在不一致的情况。</span></div>-->
        <div class="shujuBox">
          <div class="shujuBox_top">商标详情(地址不一致商标)</div>
          <div class="shujuBox2">
            <div class="xuhao">序号</div>
            <div class="fontBox21">商标名称</div>
            <div class="fontBox21">商标注册号</div>
            <div class="fontBox21">商标分类号</div>
            <div class="fontBox21">到期日期</div>
          </div>
          <div class="XunHuan"  v-for="(item,index) in companyShuju.content" :key="index">
            <div class="shujuBox3">
              <div class="xuhao">{{ (index+1) }}</div>
              <div class="flexStyle">{{ item[0] }}</div>
              <div class="flexStyle">{{ item[1] }}</div>
              <div class="flexStyle">{{ item[2] }}</div>
              <div class="flexStyle">{{ item[3] }}</div>
            </div>
          </div>
        </div>

      </div>
      <!--    主体-->
      <div class="zhuTi public_boxShaw public_Width clearfix">
        <img src="../assets/zhishi/success1.png" class="success1">
        <div class="btn226">我司客服电话：15075266990</div>
      </div>
      <div class="success2Box">
        <img src="../assets/zhishi/success2.png" class="success2">
        <div class="success2Box1" @click="boZixun"></div>
        <div class="success2Box2" @click="weiZixun"></div>
      </div>
      <div class="xaingmu public_boxShaw public_Width clearfix">
        <div class="biaotiBox">
          <img class="biaoti1" src="../assets/zhishi/biaoti.png">
          <div class="biaotiTitle">专业团队 高效办理</div>
          <img class="biaoti2" src="../assets/zhishi/biaoti.png">
        </div>
        <img class="img5" src="../assets/zhishi/img5.png">
        <img class="img6" src="../assets/zhishi/img6.png">
      </div>
      <!--    底部-->
      <bottom></bottom>
      <!--    诚信承诺书-->
      <van-dialog
        v-model="SXShu"
        confirm-button-color="#0075ff"
        confirm-button-text="已阅读"
        message-align="left"
        message="<span style='text-indent: 2em; text-align:justify;display: inline-block;line-height: 6vw;'>尊敬的用户，首先感谢您对我们的信任，我们深知个人信息对您的重要性，确保您的数据安全和隐私保护是我们重要的任务。我们将按照法律法规要求，尽力保护您的个人信息安全可控。在您使用或咨询服务前，请您务必审慎阅读并充分、透彻理解本隐私协议的全部内容和要点，<span style='color:#ff0101;'>特别应重点阅读我们以粗体/下划线标识的条款，确保您充分理解和同意后再开始使用。</span>一旦您使用或者继续咨询服务，即表示您同意本隐私<span style='color:#ff0101;'>政策</span>的全部内容，同意我们按照本协议处理您的个人信息。如果您对本隐私<span style='color:#ff0101;'>政策</span>内容有任何疑问、建议或意见，请通过本平台服务页面提供的在线客服或客服电话<span style='color:#ff0101;'>（400-056-5663）</span>联系我们，对于您不同意本隐私协议的相关内容或条款，您应该停止使用我们提供的产品和服务，<span style='color:#ff0101;'>并避免在未与我们联系的情况下提供任何个人信息。</span></span>
        <p style='display:inline-block;'>一、我们如何收集和使用您的个人信息，为了更好的向您提供产品或服务，您需要向我们授权收集和使用您必要的个人信息，若您未提供服务所必要的相关信息，将导致您无法享受我们给您提供的产品或服务。为了给您提供更好的服务，我们将收集和使用您的如下个人信息，帮助您使用本系统，我们需要您提供包括但不限于联系方式（如联系电话、联系邮箱等），用于系统的登录。</p>
        <p style='display:inline-block;'>您知悉并同意对于您提供的个人信息（包括但不限于联系方式），我们可能会用于咨询服务完成，如企业商标、专利、软件著作权等代办服务所涉及的信息填报、各类服务进度、服务推荐的通知，因此我们可能会自行或者委托第三方通过一种形式或者多种形式向您推送信息，方式主要以短信、电话方式，具体发送形式、频次以我们实际提供为准。如果您不愿接受以上信息通知，您可通过信息中提及的方式进行退订或者直接与我们联系进行退订。</p>
        <p style='display:inline-block;'>如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</p>
        <p style='display:inline-block;'>二、我们如何存储与保护您的个人信息，我们<span style='color:#ff0101;'>在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内，且</span>仅会在实现服务完成收集所需的时间内存储您的个人信息，在服务完成后（服务所对应的时间和要求）、在您主动终止服务或主动要求删除信息时，<span style='color:#ff0101;'>我们会尽快的删除您的个人信息。我们会确保依据本政策以及相关法律规定对您的个人信息提供足够的保护。</span></p>
        <p style='display:inline-block;'>我们将会用符合行业标准的安全防护措施保护您提供的个人信息，并对其中关键数据做加密处理，防止个人信息在未经授权的访问、使用、丢失、修改、公开披露或损坏。为了更好的保护您的个人信息，我们会采取<span style='color:#ff0101;'>一切</span>合理可行的措施，将接触您个人信息的范围降低到最小范围。</p>
        <p style='display:inline-block;'>三、我们如何共享、公开披露、转让您的个人信息，我们不会与我们之外的任何第三方组织、个人或者公司共享、转让您的个人信息。如果确实存在必须共享、转让您的个人信息时，我们应当确认第三方组织、个人或者公司已经征得了您的同意，并严格要求第三方对您的个人信息进行保密且使用完成后进行删除。</p>
        <p style='display:inline-block;'>我们重视个人信息的安全与保护，我们承诺不会公开披露您的个人信息，如必须时，我们会向您书面告知公开披露的信息详情与原因，并需要征得您的同意。<span style='color:#ff0101;'>如您希望将您的个人信息转移至您指定的其他个人信息处理者，如您的请求符合法律规定的条件，我们将协助您进行转移。您可以本政策载明的方式联系我们以行使上述权利。</span></p>
        <p style='display:inline-block;'>共享、转让、公开披露个人信息时会有例外，以下情形中，公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p style='display:inline-block;'>(1)您自行向社会公众公开的个人信息；<span style='opacity:0;'>xxxx</span></p>
        <p style='display:inline-block;'>(2)与国家安全、国防安全直接相关的；</p>
        <p style='display:inline-block;'>(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p style='display:inline-block;'>(4)根据个人信息主体履行法律法规规定的义务、维护其享受产品或者服务权力所必需的；</p>
        <p style='display:inline-block;'>(5)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p style='display:inline-block;'>(6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p style='display:inline-block;'>(7)国家法律法规规定的其他情形；<span style='opacity:0;'>xxxx</span></p>
        <p style='display:inline-block;'>四、个人信息主体注销账户 ，（1）您可以通过本政策载明的方式联系我们的客服申请账户注销。（2）在您注销账户之后，我们将停止为您提供产品或服务。您曾通过该账户使用的我们的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理。</p>
        <p style='display:inline-block;'>五、对本政策解释说明，如您对本政策的内容存在疑虑，您有权随时通过本政策公开的联系方式要求我们对本政策的相关内容进行解释说明。</p>
        <p style='display:inline-block;'>六、响应您的请求，（1）为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，再行处理您的请求。（2）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
        <p style='display:inline-block;'>七、我们如何处理儿童的个人信息，我们的产品、网站和服务为商用服务与产品，主要面向企业用户，一般不会向未成年人提供服务。如果我们发现自己在未事先获得未成年监护人同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关信息。</p>
        <p style='display:inline-block;'>八、如何联系我们，如果您对本个人信息保护政策有任何疑问、意见或建议，请通过以下方式与我们联系，一般情况下，我们将在十五个工作日内回复：</p>
        <p style='display:inline-block;'>个人信息保护联系电话：【400-056-5663】</p>
        <p style='display:inline-block;'>个人信息保护联系邮箱：【qishangbanzixun@163.com】</p>
">
        <p slot="title" class="slotTitle">《信息授权与隐私政策》</p>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { companyInfo, orderGet } from '@/http/api/user'
import bottom from '@/components/bottom.vue'

export default {
  name: 'success',
  // 注册组件
  components: { bottom },
  // 数据渲染
  data () {
    return {
      ShowOK: true,
      // 支付选择
      radio: '2',
      // 随机值
      randomNum: '',
      // 按钮效果1
      BtnActive: false,
      companyShuju: null,
      // 诚信承诺书
      SXShu: false,
      checked1: true
    }
  },
  // 注册方法
  methods: {
    // 信息初始
    async companyInfo (num) {
      const { data } = await companyInfo(qs.stringify({
        random: this.randomNum,
        type: num
      }))
      this.companyShuju = data
    },
    // 订单查询
    async chaxun () {
      const data = await orderGet(qs.stringify({
        order_no: localStorage.getItem('orderNo')
      }))
      if (data.code !== 200) {
        this.ShowOK = false
        window.location.href = 'https://y8q.cn/A/ShouYe/' + this.randomNum
      } else {
        this.ShowOK = true
      }
    },
    // 拨打客服电话
    boZixun () {
      window.location.href = 'tel://15075266990'
    },
    // 微信客服
    weiZixun () {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc2f7ba12adb97363c'
    }
  },
  // 页面初次解析完成
  created () {
    window.scrollTo({
      left: 0,
      top: 0
    })
    this.randomNum = localStorage.getItem('RandomNum')
    this.chaxun()
    // 公司信息
    this.companyInfo(1)
  },
  // 页面内容渲染完成
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.xuhao{
  padding-left: 6px;
  width: 30px;
  text-align: center;
  font-weight: 500;
  font-size: 11px;
  color: #333333;
}
.shujuBox {
  width: 325px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #C39E5C;
  margin: 5px auto 0;
  font-size: 12px;
  overflow: hidden;
  .shujuBox_top{
    width: 325px;
    height: 33px;
    background-color: #FC6701;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    line-height: 33px;
    color: #FFFFFF;
  }
  .XunHuan{
    .shujuBox3{
      display: flex;
      align-items: center;
      width: 324px;
      height: 28px;
      border-bottom: 1px solid #EBD1AE;
      .flexStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        text-align: center;
        font-size: 10px;
        color: #333333;
      }
    }
  }
  .XunHuan .shujuBox3:last-child{
    border-bottom: none;
  }
  .shujuBox2{
    margin-top: 8px;
    width: 324px;
    height: 28px;
    background: linear-gradient(-78deg, #FFEEE6, #FEE9EE);
    display: flex;
    align-items: center;
    .fontBox21{
      flex: 1;
      font-weight: 500;
      text-align: center;
      font-size: 11px;
      color: #333333;
    }
  }
}

// 悬浮
.v-enter-active,
.v-leave-active {
  transform: translateY(100px);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(100px);
}
// 立即领取悬浮
.LiJiBtn{
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 50px;
  transition: all .9s;
  background-color: #fff;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 1px 4px 1px rgba(191,191,191,0.52);
}
.imgFlex{
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.LiJiBtn_img_right{
  margin-right: 15px;
}
.LiJiBtn_img{
  width: 130px;
}
// 守信承诺书标题
.slotTitle {
  font-size: 18px;
  color: #0075ff;
}

// 守信承诺书内容
.slotdefault {
  padding: 4px 24px 4px 24px;
  font-size: 14px;
}

.slotdefault1 {
  text-indent: 2em;
  line-height: 22px;
  color: #646566;
}

.slotdefault2, .slotdefault3 {
  color: #646566;
}

.slotdefault3 {
  text-align: right;
}

.slotdefault4 {
  padding-bottom: 20px;
}

// 客服
.kefu_class {
  position: fixed;
  right: 0px;
  bottom: 70px;
}

.v-enter-active,
.v-leave-active {
  transform: translateY(100px);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(100px);
}

@keyframes Liji {
  0% {
    transform: scale(1) translate(-50%, -50%);
  }
  25% {
    transform: scale(.95) translate(-50%, -50%);
  }
  100% {
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes Liji2 {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(.95);
  }
  100% {
    transform: scale(1);
  }
}

#ShouYe {
  position: relative;
}

.touBox1 {
  height: 480px;
  background-image: url("../assets/zhishi/index-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.logoImg{
  margin-top: 10px;
  margin-left: 20px;
  height: 27px;
}

.zhuTi2 {
  padding: 13px 0;
  margin-top: 20px;
  background-color: #fdf4ea;
  .font226Xin{
    width: 100%;
    text-align: center;
    font-weight: 400;
    font-size: 17px;
    color: #FC6701;
  }
  .font226Xin2{
    width: 306px;
    margin: 8px auto 0;
    font-size: 13px;
    color: #333333;
  }
}
.success2Box{
  position: relative;
  margin: 0 auto 10px;
  width: 345px;
  box-shadow: 0 1px 3px 1px rgba(169,112,70,0.52);
  border-radius: 10px;
}
.success2Box1{
  width: 150px;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.success2Box2{
  width: 150px;
  height: 50px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.success2{
  display: block;
  width: 100%;
}
.zhuTi {
  padding: 0 0 14px 0;
  background-color: #ffffff;
  .success1{
    display: block;
    margin: 20px auto 15px;
    width: 300px;
  }
  .btn226{
    margin: 0 auto 8px;
    width: 325px;
    height: 39px;
    background: #FC6701;
    border-radius: 8px;
    font-weight: 400;
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    line-height: 39px;
  }
}

.xaingmu {
  .img5 {
    display: block;
    margin: 3px auto 0;
    width: 315px;
  }

  .img6 {
    display: block;
    margin: 4px auto 15px;
    width: 305px;
  }

  .biaotiBox {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .biaoti1 {
      width: 36px;
      height: 4px;
    }

    .biaotiTitle {
      margin-left: 5px;
      margin-right: 5px;
      font-weight: bold;
      font-size: 17px;
      color: #B16A2C;
    }

    .biaoti2 {
      width: 36px;
      height: 4px;
      transform: rotate(180deg);
    }
  }

  .fuwu {
    margin: 15px auto 0;
    display: block;
    width: 315px;
    height: 190px;
  }

  .biaotiBox2 {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .zixun1 {
      margin-right: 15px;
    }

    .zixun1,
    .zixun2 {
      width: 150px;
      height: 37px;
    }
  }
}

.zhishi2 {
  .zhishi {
    padding: 13px 13px 15px 13px;
    display: flex;
    margin: 0 auto;
    width: 323px;
    height: 315px;
  }
}
</style>
